import { Component, OnInit } from '@angular/core';
import { GoogleService } from '../../../services/google.service';

@Component({
  selector: 'app-unread-emails',
  templateUrl: './unread-emails.component.html',
  styleUrls: ['./unread-emails.component.css']
})
export class UnreadEmailsComponent implements OnInit {
  unreadCount: number = 0;

  constructor(private gmailService: GoogleService) {}

  ngOnInit(): void {
    this.fetchUnreadEmails();
  }

  fetchUnreadEmails(): void {
    this.gmailService.getUnreadEmailCount().subscribe({
      next: (count: number) => {
        this.unreadCount = count;
      },
      error: (error: any) => {
      }
    });
  }
}
